import {gsap} from "../../../libs/gsap/all.js";
import * as PIXI from "pixi.js";
import 'pixi.js/math-extras';
import {HarponTile} from "./HarponTile";

// Constructor
export class EndHarponTile extends HarponTile {

  constructor(rowIndex, colIndex) {
    super(rowIndex, colIndex);

    this.isValidMove = true;
    this.type = "end";

    this.build();
  }

  build() {
    super.build();

  }

  test() {

  }

  show() {

  }

  endOfTurnAction() {
    // To be overwritten in child if needed
    if (this.playerIsOnTile()) {
      app.game.gameComplete = true;
      app.audio.play(app.data.global.sounds.game_won, 1.0, true);
    }
  }

  // Reset the states so we can animate in again and start over
  reset() {
  }


}
